export type FolderType = "all" | "integration" | "migration" | "sftp";

export interface GetFileSystemRequest {
  prefix: string;
  continuation_token: string | null;
  search: string | null;
  limit: number | null;
  folder_type?: FolderType;
  page?: number;
  sort_field?: "name" | "date" | "size";
  sort_order?: "asc" | "desc";
}

export interface DownloadFileRequest {
  source: string;
  fileName: string;
}

export interface DownloadArchiveRequest {
  source: string;
  fileName: string;
}

export type FolderSyncStatus = "syncing" | "ready" | "failed";

export interface FileSystemResponse {
  continuation_token: string | null;
  folders: FileItem[];
  show_filter: boolean | null;
  show_sftp_filter?: boolean;
  total_count?: number;
  total_pages?: number;
  current_page?: number;
  has_direct_files?: boolean;
  sync_status?: FolderSyncStatus;
}

export interface FileItem {
  fname: string;
  ftype: string;
  fsource: string;
  last_modified?: string;
  file_size?: number;
  file_count?: number;
  subfolder_count?: number;
  direct_file_count?: number;
  sync_status?: FolderSyncStatus;
  is_sftp_folder?: boolean;
}

export interface DownloadFileResponse {
  next_token: string | null;
  file_urls: string[];
}

export interface DownloadArchiveErrorResponse {
  error: string;
}

export interface DownloadArchiveUrlResponse {
  download_url: string;
  filename: string;
}

export type DownloadArchiveResponse =
  | Blob
  | DownloadArchiveErrorResponse
  | DownloadArchiveUrlResponse;

export const isDownloadArchiveError = (
  response: DownloadArchiveResponse,
): response is DownloadArchiveErrorResponse => {
  return (
    typeof response === "object" && response !== null && "error" in response
  );
};

export const isDownloadArchiveBlob = (
  response: DownloadArchiveResponse,
): response is Blob => {
  return response instanceof Blob;
};

export const isDownloadArchiveUrl = (
  response: DownloadArchiveResponse,
): response is DownloadArchiveUrlResponse => {
  return (
    typeof response === "object" &&
    response !== null &&
    "download_url" in response
  );
};
